export enum usersTypes {
  PRACTITIONER,
  PATIENT
}
